import { defineMessages } from 'react-intl'

export const myAccountMessages = defineMessages({
  myAccount: {
    id: 'myAccount.myAccount',
    description: 'My Account/Profile page title',
    defaultMessage: 'My Account',
  },
  profileInfo: {
    id: 'myAccount.profileInfo',
    description: 'Header of account section about user profile info',
    defaultMessage: 'User Info',
  },
  password: {
    id: 'myAccount.password',
    description: 'Header of account section about user password',
    defaultMessage: 'Password',
  },
  changePassword: {
    id: 'myAccount.changePassword',
    description: 'Change Password page title',
    defaultMessage: 'Account Security',
  },
  changePassInstructions: {
    id: 'myAccount.changePassInstructions',
    description: 'Text about next steps to change the password',
    defaultMessage:
      "To change your account's password use the button below. \n We will send you an email with instructions about how to reset your password.",
  },
  changePassModalHeading: {
    id: 'myAccount.changePassModalHeading',
    description: 'Modal header when email to change/reset password sent',
    defaultMessage: 'Email Sent!',
  },
  changePassModalText: {
    id: 'myAccount.changePassModalText',
    description: 'Modal text when email to change/reset password sent',
    defaultMessage: 'Check your inbox to proceed with resetting password',
  },
  changePassModalClose: {
    id: 'myAccount.changePassModalClose',
    description:
      'Button text to close modal when email to change/reset password sent',
    defaultMessage: 'Close',
  },
  manageService: {
    id: 'myAccount.manageService',
    description:
      'Text describing what user should do to be able to change "service-level" permissions/change photo',
    defaultMessage: 'Use the Savant Pro App to set service level permissions',
  },
  firstName: {
    id: 'myAccount.firstName',
    description: 'Input placeholder text for user "First Name"',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'myAccount.lastName',
    description: 'Input placeholder text for user "Last Name"',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'myAccount.email',
    description: 'Input placeholder text for user "Email"',
    defaultMessage: 'Email',
  },
  twoFactorHeading: {
    id: 'myAccount.twoFactorHeading',
    description: 'Header for two factor authentiaction enabling',
    defaultMessage: 'Additional Account Verification',
  },
  twoFactorText: {
    id: 'myAccount.twoFactorText',
    description: 'Text for two factor authentiaction enabling',
    defaultMessage:
      'Increase your account’s security by requiring additional verification. Whenever you sign in, we will send you a verification code you will be required to enter. Enabling this will require you to re-sign in on all apps. {br}{br}If enabled, you will NOT be able to sign in to Savant Legacy apps such as Savant Pro 7, Savant Pro 8, Savant (White Logo), Savant Lighting, Savant Studio, and Cloud File Manager.',
  },
  twoFactorToggle: {
    id: 'myAccount.twoFactorToggle',
    description: 'Label for two factor authentiaction enabling',
    defaultMessage: 'Additional Account Verfication Enabled',
  },
  twoFactorError: {
    id: 'myAccount.twoFactorError',
    description: 'Error message for two factor authentiaction enabling',
    defaultMessage:
      'There was an error verifying your Two-factor Authentication. Please make sure your code is valid.',
  },
  enabled: {
    id: 'myAccount.enabled',
    description: 'Message for two factor enabled toggle',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'myAccount.disabled',
    description: 'Message for two factor disabled toggle',
    defaultMessage: 'Disabled',
  },
  verifyCode: {
    id: 'myAccount.verifyCode',
    description: 'Text of verification code button',
    defaultMessage: 'Verify',
  },
  codeLengthError: {
    id: 'myAccount.codeLengthError',
    description: 'Error text of verification code input length',
    defaultMessage: 'Must be 6 characters long',
  },
  enterCode: {
    id: 'myAccountenterCode',
    description: 'Text pointing that user should enter verification code',
    defaultMessage:
      'Please enter the 6 digit code below. Your code expires in 30 minutes.',
  },
  resendDescription: {
    id: 'myAccountresendDescription',
    description: 'Description text for resend link',
    defaultMessage: 'Can’t find our Email? ',
  },
  resendCode: {
    id: 'myAccountresendCode',
    description: 'Text of resend 2fa verification Code',
    defaultMessage: 'Resend Verification',
  },
  twoFactor: {
    id: 'myAccounttwoFactor',
    description: 'Placeholder text of verification Code',
    defaultMessage: 'Verification Code',
  },
})
